import { Map as ImmutableMap } from 'immutable';
import { COLUMN_ROLES } from '../constants/relationalReports';
import { KEY_PATHS } from '../relational/reports/keyPaths';
import { GENERATED_COLUMN_PREFIXES } from '../relational/reports/column-records';
const get = keyPath => {
  return report => {
    if (report.getIn) {
      // @ts-expect-error Can't convert readonly REPORT_DEFINITION_KEY_PATHS to mutable string[]
      return report.getIn(keyPath);
    }
    throw new Error('Report does not support getIn');
  };
};
export const getReportDefinition = get(KEY_PATHS.REPORT_DEFINITION);
export const getColumns = get(KEY_PATHS.COLUMNS);
export const getNonGeneratedColumns = report => {
  const columns = getColumns(report);
  return columns.filter(column => !GENERATED_COLUMN_PREFIXES.some(prefix => column.get('alias').startsWith(prefix)));
};
export const getDimensionsFromRelationalReport = (report, includeGeneratedColumns = true) => {
  const columns = includeGeneratedColumns ? getColumns(report) : getNonGeneratedColumns(report);
  return columns.filter(column => column.get('role') === COLUMN_ROLES.DIMENSION).map(column => column.getIn(['field', 'name'])).toList();
};
export const getMetricPropertyAndAggregationFromRelationalReport = (report, includeGeneratedColumns = true) => {
  const columns = includeGeneratedColumns ? getColumns(report) : getNonGeneratedColumns(report);
  return columns.filter(column => column.get('role') === COLUMN_ROLES.MEASURE).map(column => ImmutableMap({
    property: column.getIn(['field', 'name']),
    aggregation: column.get('aggregation')
  })).toList();
};
export const getFiltering = get(KEY_PATHS.FILTERING);
export const getVisual = get(KEY_PATHS.VISUAL);
export const getReportDefinitionTable = get(KEY_PATHS.TABLE);
export const getRelationalReportTableName = get(KEY_PATHS.TABLE_NAME);
export const getRelationalReportDatasetId = get(KEY_PATHS.DATASET_ID);
export const getRelationalReportColorOptions = get(KEY_PATHS.VISUAL_OPTIONS_COLOR);
export const getRelationalReportY1ColorOptions = get(KEY_PATHS.VISUAL_OPTIONS_Y1COLOR);
export const getRelationalReportY2ColorOptions = get(KEY_PATHS.VISUAL_OPTIONS_Y2COLOR);
export const getRelationalReportVisualType = get(KEY_PATHS.VISUAL_TYPE);
export const getFilteringFromRelationalReport = get(KEY_PATHS.FILTERING);